export default "__VITE_ASSET__DQHhshtX__"